import React, {
  useState,
  ReactNode,
  createContext,
  useEffect,
  useContext,
} from "react";
import { useLocation } from "react-router";
import { Globe2, PeopleFill } from "react-bootstrap-icons";
import i18n from "../../constants/languages";
import "bootstrap/dist/css/bootstrap.min.css";
import "./layout.css";
import SideBar from "./Sidebar";
import LoadingSpinner from "../../components/Loader/Loader";
import { FaArrowAltCircleLeft, FaChevronLeft, FaChevronRight, FaUserCircle } from "react-icons/fa";
import { Outlet } from "react-router";
import { Form } from "react-bootstrap";
import ClaimOnBehalfModal from "../../components/ClaimOnBehalfModal/ClaimOnBehalfModal";
import { useLogout } from "../../AuthComponent";
import appConfig from "../../constants/config";

//Toast
import { ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../components/AuthProvider/useAuth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faEyeSlash,
  faArrowRightToBracket,
  faRefresh,
  faArrowLeftRotate,
  faArrowLeftLong,
  faArrowAltCircleLeft,
  faArrowCircleLeft,
  faArrowsLeftRightToLine,
  faCaretLeft,
  faAngleLeft,
  faQuoteLeft,
  faChevronLeft,
  faCircleArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import InstallPrompt from "../../components/InstallPrompt/InstallPrompt";
import PullToRefresh from "react-simple-pull-to-refresh";
// import QrCode from "../QrCodeInstall/QrCode/QrCode";
import InstallPromptFooter from "../../components/InstallPrompt/InstallPromptFooter";
import { setGlobalLocation } from "../../utils/globalManager";
import { translate } from "../../utils/translateUtils";
import { useNavigate } from "react-router";

import "bootstrap/dist/css/bootstrap.min.css";
import "./layout.css";
import "primeflex/primeflex.css";
import { getObjectRequester } from "../../utils/localStorage/localStorage";
import { isNullOrEmpty } from "../../utils/formValidation";

const logo = require("../../assets/images/logo_dksh_new.png");

type OS = "Windows" | "MacOS" | "iOS" | "Android" | "Linux" | "Unknown";

interface MasterContainerProps {
  children: ReactNode;
  loading?: boolean; // Add the 'loading' property as optional
}

export const MasterContainerContext = createContext<MasterContainerContextType>(
  {} as MasterContainerContextType
);

export function isPWA() {
  // Check for both Android/desktop browsers and iOS
  return window.matchMedia('(display-mode: standalone)').matches || window.navigator?.standalone === true;
}

export const MasterContainerHeaderContext =
  createContext<MasterContainerHeaderContextType>(
    {} as MasterContainerHeaderContextType
  );

interface MasterContainerContextType {
  language: string;
  setLanguage: React.Dispatch<React.SetStateAction<string>>;
  screenWidth: number;
  platform: string;
  os: string;
  currentLocation: any;
  environment: any;
}

interface MasterContainerHeaderContextType {
  headerContent: string;
  setHeaderContent: (headerContent: string) => void;
}

// Create a context
const ScreenWidthContext = createContext<number>(window.innerWidth);
const PlatformContext = createContext<string>("isDesktop");
const LocationContext = createContext<any>(null);
const EnvironmentContext = createContext<string>("");

const MasterContainer: React.FC<MasterContainerProps> = ({ children }) => {
  const location = useLocation();
  const [currentLocation, setCurrentLocation] = useState(location);
  const [isToggleActive, setToggleActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const [language, setLanguage] = useState(
    window.sessionStorage.getItem("selectedLanguage") ?? "en"
  );

  const [claimOnBehalfVisible, setClaimOnBehalfVisible] = useState(false);
  const { currentUser, isImpersonated, unImpersonate } = useAuth();
  const [headerContent, setHeaderContent] = useState<string>("");
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  const [platform, setPlatform] = useState<string>("");
  const [environment, setEnvironment] = useState<string>("");
  const [os, setOS] = useState<OS>("Unknown");
  const [qrCodeDisplay, setQrCodeDisplay] = useState(true);
  const handleLogout = useLogout();
  const navigate = useNavigate();

  const languages = [
    { name: "English (EN)", code: "en" },
    { name: "한국어 (KR)", code: "kr" },
    { name: "日本語 (JP)", code: "jp" },
    { name: "中文 (CN)", code: "cn" },
    { name: "ภาษาไทย (TH)", code: "th" },
    { name: "Bahasa Indonesia (ID)", code: "id" },
    { name: "ພາສາລາວ (LA)", code: "la" },
    { name: "國語 (TW)", code: "tw" },
    { name: "Cambodian (KH)", code: "kh" },
  ];

  const name = currentUser
    ? currentUser.requesor
    : localStorage.getItem("ADProfileName");

  function changeLanguage(lng: any) {
    i18n.changeLanguage(lng).then(() => {
      setLanguage(lng);
      window.sessionStorage.setItem("selectedLanguage", lng);
      localStorage.setItem("Language", lng);
    });
  }

  function toggleNavBar() {
    setToggleActive(!isToggleActive);
    isToggleActive
      ? localStorage.setItem("sidebar.active", "true")
      : localStorage.setItem("sidebar.active", "false");
  }

  const handleRefresh = async () => {
    window.location.reload();
  };

  const detectEnvironment = (): any => {
    if (isPWA()) {
      setEnvironment("pwa");
      return "pwa";
    } else {
      setEnvironment("web");
      return "web";
    }
  };

  const detectOS = (): OS => {
    const { userAgent, platform } = window.navigator;

    // For iOS detection, check for specific platforms
    if (/iPhone|iPad|iPod/.test(platform)) {
      return "iOS";
    }

    // For Mac detection
    if (platform.includes("Mac")) {
      return "MacOS";
    }

    // For Windows detection
    if (platform.includes("Win")) {
      return "Windows";
    }

    // For Android detection
    if (/Android/.test(userAgent)) {
      return "Android";
    }

    // For Linux detection
    if (/Linux/.test(platform)) {
      return "Linux";
    }

    // Default case for unknown OS
    return "Unknown";
  };

  useEffect(() => {
    // let objRequestor = getObjectRequester();
    // if(!isNullOrEmpty(objRequestor)) {
    //   if(!appConfig.PWACountryList.includes(objRequestor.country_code)){
    //       alert('Your country currently do not have permission to access EEC PWA. Rerouting to EEC Plus.');
    //       window.location.href = 'https://eec.dksh.com/';
    //       localStorage.clear();
    //   }
    // }
    const hasReloaded = localStorage.getItem("reloaded");

    if (!hasReloaded) {
      // Set the flag so that reload happens only once
      localStorage.setItem("reloaded", "true");
      // Reload the window
      handleRefresh();
    }

    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      if (window.innerWidth <= 768) {
        setPlatform("isMobile");
        setQrCodeDisplay(false);
      } else if (window.innerWidth <= 1024) {
        setPlatform("isTab");
        setQrCodeDisplay(false);
      } else {
        if (window.innerWidth <= 1500) {
          (document.body.style as any).zoom = "80%";
        } else {
          (document.body.style as any).zoom = "92%";
        }
        setPlatform("isDesktop");
        setQrCodeDisplay(true);
      }
    };

    // const detectOS = (): OS => {
    //   const { userAgent, platform } = window.navigator;

    //   // For iOS detection, check for specific platforms
    //   if (/iPhone|iPad|iPod/.test(platform)) {
    //     return "iOS";
    //   }

    //   // For Mac detection
    //   if (platform.includes("Mac")) {
    //     return "MacOS";
    //   }

    //   // For Windows detection
    //   if (platform.includes("Win")) {
    //     return "Windows";
    //   }

    //   // For Android detection
    //   if (/Android/.test(userAgent)) {
    //     return "Android";
    //   }

    //   // For Linux detection
    //   if (/Linux/.test(platform)) {
    //     return "Linux";
    //   }

    //   // Default case for unknown OS
    //   return "Unknown";
    // };

    // // Define visibility change handler
    // const handleVisibilityChange = () => {
    //   if (document.visibilityState === "visible") {
    //     detectEnvironment();  // Recheck if app is in PWA or browser when visible again
    //   }
    // };



    window.addEventListener("resize", handleResize);
    // // Detect environment when switching to PWA from browser
    // document.addEventListener('visibilitychange', handleVisibilityChange);
    // if (isPWA() && !sessionStorage.getItem('pwaReloaded')) {
    //   sessionStorage.setItem('pwaReloaded', 'true');
    //   window.location.reload();
    // }

    handleResize();
    setOS(detectOS());
    setEnvironment(detectEnvironment());
    localStorage.setItem("OS", detectOS());
    localStorage.setItem("Environment", detectEnvironment() == "pwa" ? "App" : "Web");
    return () => {
      window.removeEventListener("resize", handleResize);
      // document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    setCurrentLocation(location);
    setGlobalLocation(location)
  }, [location]);

  return (
    <MasterContainerContext.Provider
      value={{ language, setLanguage, screenWidth, platform, os, currentLocation, environment }}
    >
      <MasterContainerHeaderContext.Provider
        value={{ headerContent, setHeaderContent }}
      >
        <div className="container-fluid p-0">
          <div className="wrapper">
            {/* Sidebar Holder */}
            <nav
              id="sidebar"
              style={{ zIndex: "10", minHeight: "100vh" }}
              className={`${isToggleActive ? "active" : "inactive"}`}
            >
              <div className="sidebar-container d-flex flex-column d-print-none">
                {/* Side bar header  */}
                <div className="sidebar-header">
                  <div className="p-3 d-flex flex-column gap-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="user-icon" style={{ paddingLeft: 5 }}>
                        <FaUserCircle fontSize={40} />
                      </div>
                      <div
                        className="user-name pl-3"
                        style={{ minWidth: "170px" }}
                      >
                        <strong style={{ display: "block" }}>{name}</strong>

                        {isImpersonated && (
                          <small style={{ opacity: 0.8 }}>
                            <FontAwesomeIcon icon={faEye} /> Claiming on Behalf
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="space sidebar-hidden-display-none" />

                    {/* End claim on behalf */}
                    {isImpersonated && (
                      <div
                        id="sidebar-nav-a"
                        data-toggle="modal"
                        data-target="#onBehalfUserModal"
                        className="name d-flex align-items-center end-claim-on-behalf-div"
                        style={{
                          cursor: "pointer",
                          textDecoration: "underline",
                          padding: "10px",
                          width: "100%"
                        }}
                        onClick={() => {
                          unImpersonate();

                          const windowLocation = window.location.href;
                          const virtualPathIndex = windowLocation.indexOf(window.location.pathname);

                          switch (true) {
                            case windowLocation.includes("ClaimItems"):
                              navigate(`/ClaimItems/ClaimItems`);
                              break;
                            case windowLocation.includes("ExpReport"):
                              navigate(windowLocation.slice(virtualPathIndex).split("&")[0].replace(appConfig.connectionString.appBaseName, ""));
                              break;
                            case windowLocation === "":
                              navigate("/not-found");
                              break;
                            default:
                              navigate(windowLocation.slice(virtualPathIndex).replace(appConfig.connectionString.appBaseName, ""));
                              break;
                          }

                        }}
                      >
                        <FontAwesomeIcon
                          icon={faEyeSlash}
                          style={{ marginLeft: 5, fontSize: 20 }}
                        />
                        <span
                          className=""
                          data-tag="claim_on_behalf"
                          style={{ marginLeft: 13 }}
                        >
                          {translate("End Claim on Behalf")}
                        </span>
                      </div>
                    )}

                    {/* Claim on behalf */}
                    <div className="d-flex align-items-center claim-on-behalf-div">
                      <div
                        id="sidebar-nav-a"
                        data-toggle="modal"
                        data-target="#onBehalfUserModal"
                        className="name d-flex align-items-center"
                        style={{ cursor: "pointer", width: "100%", padding: "10px" }}
                        onClick={() => setClaimOnBehalfVisible(true)}
                      >
                        <PeopleFill fontSize={20} style={{ marginLeft: 5 }} />
                        <span
                          data-tag="claim_on_behalf"
                          style={{ marginLeft: 16 }}
                        >
                          {translate("Claim on Behalf")}
                        </span>
                      </div>
                      <i
                        data-toggle="modal"
                        data-target="#onBehalfUserModal"
                        style={{ cursor: "pointer" }}
                        className="fa-solid fa-chevron-right sidebar-icon-right"
                      ></i>
                    </div>

                    {/* Mobile Dropdown */}
                    <div id="mobile-lang" className="mobile-lang">
                      <Globe2
                        style={{
                          height: "25px",
                          width: "23px",
                          verticalAlign: "bottom",
                          marginTop: "5px",
                        }}
                      ></Globe2>
                      <Form.Select
                        value={language}
                        onChange={(e) => changeLanguage(e.target.value)}
                        style={{ width: "80%", marginLeft: 10 }}
                      >
                        {languages.map((item, index) => (
                          <option key={index} value={item.code}>
                            {item.name}
                          </option>
                        ))}
                      </Form.Select>
                    </div>
                  </div>
                </div>

                <div className="space sidebar-hidden-display-none" />
                <div
                  id="dismiss"
                  className="left-sidebar"
                  onClick={toggleNavBar}
                >
                  <FaChevronLeft className="icon" style={{ color: "white" }} />
                </div>
                <div className="sidebar-content  flex-1">
                  <div
                    id="dismiss"
                    className="left-sidebar"
                    onClick={toggleNavBar}
                  >
                    <FaChevronLeft
                      className="icon"
                      style={{ color: "white" }}
                    />
                  </div>
                  <SideBar
                    parentModuleId={null}
                    setLoading={setLoading}
                    setToggleSideBar={setToggleActive}
                  />
                </div>
                <div className="space sidebar-hidden-display-none" />
                <div className="sidebar-footer nav-footer d-flex flex-column">
                  <div
                    style={{
                      borderBottom: "1px solid white",
                      borderTop: "1px solid white",
                      width: "100%",
                      minHeight: "30px",
                    }}
                    className="d-flex justify-content-center align-items-center mb-4"
                    id="userManualDiv"
                  >
                    <span
                      id="userManual"
                      style={{ width: "100%", textAlign: "center" , lineHeight:'3'}}
                      onClick={() =>
                        window.open(appConfig.HelpFileLink, "_blank")
                      }
                    >
                      User manual and tutorials
                    </span>
                  </div>
                  <div
                    className="btn btn-eec-plus d-flex gap-2 justify-content-center "
                    style={{ color: "#BE0028", background:"white", fontWeight:"bold", cursor:"pointer"}}
                    onClick={()=>{
                      localStorage.setItem("toEECPlus", "1");
                      // toEECPlus is stored per-origin, so it can't be read on the legacy domain after
                      // navigating there. Pass it as a query param too so eecplus.dksh.com can persist
                      // it into its own localStorage and skip its PWA auto-redirect for this visit.
                      const legacyUrl = appConfig.LegacySystemUrl;
                      window.location.href = legacyUrl + (legacyUrl.includes("?") ? "&" : "?") + "toEECPlus=1";
                    }} //Terk Amendment 20251001 : PWA Live START
                  >
                    <FontAwesomeIcon icon={faCircleArrowLeft} />
                    <span className="text-link">{translate("To EEC Plus")}</span>
                  </div>
                  <br/>
                  <div
                    className="btn btn-logout d-flex gap-2 justify-content-center "
                    style={{ color: "white" }}
                    onClick={handleLogout}
                  >
                    <FontAwesomeIcon icon={faArrowRightToBracket} />
                    <span className="text-link">{translate("Log Out")}</span>
                  </div>
                </div>
              </div>
            </nav>

            {/* Page Content Holder */}
            <div className="container-wrap container-fluid p-0 m-0 d-flex flex-column">
              <div className={`content-header d-flex ${platform == "isMobile" ? "" : "p-2"} justify-content-between`}>
                <div
                  className="align-items-sm-center d-flex"
                  style={{ padding: "0px!important" }}
                >
                  <div
                    id="toggle-navbar"
                    onClick={toggleNavBar}
                    className={`rect navbar-toggle ${isToggleActive ? "display-hidden" : "d-flex"
                      }`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      fill="currentColor"
                      className="bi bi-list"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
                      />
                    </svg>
                  </div>
                  <div
                    className="pb-sm-0 pl-sm-0 d-flex justify-content-start align-items-center"
                    id="headerContent"
                  >
                    {headerContent && (
                      <img
                        className="icon-header"
                        alt={headerContent}
                        src={`${window.location.origin}${appConfig.connectionString.appBaseName
                          }/images/icon_${headerContent
                            .toLowerCase()
                            .replace(" ", "_")
                            .replace(" ", "_")}.png`}
                      />
                    )}
                    <h3 className="title-header fs-sm-2">{translate(headerContent)}</h3>
                  </div>
                </div>
                <div className=" align-items-center d-flex justify-content-end gap-20">
                  <div className="content-header-dropdown d-flex d-none d-sm-block  d-md-block d-lg-block">
                    <Form.Select
                      value={language}
                      id={"lang-web"}
                      style={{ width: 165 }}
                      onChange={(e) => changeLanguage(e.target.value)}
                    >
                      {languages.map((item, index) => (
                        <option key={index} value={item.code}>
                          {item.name}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                  <div className="pb-sm-0 pr-2 pr-sm-0 content-dksh d-flex">
                    <div className="logo">
                      <img src={logo} alt="Logo" /><br />
                      <div style={{ fontSize: '11px', fontWeight: 'bold', color: "darkred", textAlign: "right" }}>{environment == "pwa" ? "App " : "Web "}Version {appConfig.Version}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="content-body row mx-0 "
                style={{ flex: "auto", overflow: "auto" }}
              >
                <div className="scroll-y">
                  <div id="myNav" className="" style={{ display: "none" }}>
                    {/* Button to close the overlay navigation */}
                    <i className="fa fa-times cursor fa-3x claim_detail_close_btn"></i>
                    <div className="jumbotron">
                      <div
                        id="myCarousel"
                        className="carousel slide carousel-inner"
                        data-ride="carousel"
                        data-interval="false"
                      >
                        <div
                          id="carouselItems"
                          className="h-100 w-100"
                          style={{ margin: "auto" }}
                        ></div>
                        <a
                          className="carousel-control-prev"
                          href="#myCarousel"
                          role="button"
                          data-slide="prev"
                        >
                          <span className="" aria-hidden="true">
                            <i
                              className="fa fa-2x fa-angle-left"
                              style={{ color: "#be0028" }}
                            ></i>
                          </span>
                          <span className="sr-only">Previous</span>
                        </a>
                        <a
                          className="carousel-control-next"
                          href="#myCarousel"
                          role="button"
                          data-slide="next"
                        >
                          <span className="" aria-hidden="true">
                            <i
                              className="fa fa-2x fa-angle-right"
                              style={{ color: "#be0028" }}
                            ></i>
                          </span>
                          <span className="sr-only">Next</span>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div
                    id="divLayout"
                    className="partial-container  h-100 w-100"
                  >
                    <span
                      id="Are_you_sure_you_want_to_continue"
                      style={{ display: "none" }}
                      data-tag="Are_you_sure_you_want_to_continue"
                    >
                      Are you sure you want to continue?
                    </span>
                    <span
                      id="submit_terms_and_conditions"
                      style={{ display: "none" }}
                      data-tag="submit_terms_and_conditions"
                    >
                      I here by acknowledge and confirm that the submitted claim
                      item has violated the local policy whereby the receipt
                      date has exceeded{" "}
                    </span>
                    <span
                      id="submit_terms_and_conditions_1"
                      style={{ display: "none" }}
                      data-tag="submit_terms_and_conditions_1"
                    >
                      {" "}
                      days. I agree that DKSH reserve the right not to honor
                      this submission. I take full responsibility for this
                      action and the potential consequences associated with this
                      submission and understand that it may lead to further
                      disciplinary action.
                    </span>
                    <span
                      id="superior_submit_terms_and_conditions"
                      style={{ display: "none" }}
                      data-tag="superior_submit_terms_and_conditions"
                    >
                      I hereby consent to this expired expense report and
                      acknowledge that this submission failed to comply with the
                      local policy.
                    </span>
                    <span
                      id="Cancel"
                      style={{ display: "none" }}
                      data-tag="Cancel"
                    >
                      Cancel
                    </span>
                    <span
                      id="Confirm"
                      style={{ display: "none" }}
                      data-tag="Confirm"
                    >
                      Confirm
                    </span>
                    <div className="">
                      <PullToRefresh onRefresh={handleRefresh} pullDownThreshold={150} maxPullDownDistance={180}>
                        <div
                          id="divLayout"
                        // className="partial-container mb-sm-4 h-100 w-100"
                        >
                          {environment == "pwa" && platform == "isDesktop" ?
                            <button className={`btn btn-danger button-app-refresh`} style={{ marginLeft: "10px" }} onClick={() => { window.location.reload(); }}>
                              <FontAwesomeIcon icon={faRefresh} />&nbsp; &nbsp; {translate("Refresh")}</button>
                            : <></>
                          }
                          {loading ? (
                            <LoadingSpinner loading={loading} />
                          ) : (
                            children
                          )}
                          <Outlet />
                        </div>
                      </PullToRefresh>
                    </div>
                  </div>
                </div>
              </div>
              <InstallPromptFooter platform={platform} environment={environment} setEnvironment={setEnvironment} isPWA={isPWA} detectEnvironment={detectEnvironment} />
            </div>
          </div>
        </div>
        <ToastContainer
          position="top-right"
          theme="light"
          transition={Zoom}
          style={{
            marginTop: "30px",
            marginLeft: "30px",
            right: "10px",
            minWidth: "400px",
          }}
        />
        <ClaimOnBehalfModal
          visible={claimOnBehalfVisible}
          onClose={() => setClaimOnBehalfVisible(false)}
        />
        {/* <InstallPrompt /> */}
      </MasterContainerHeaderContext.Provider>
    </MasterContainerContext.Provider>
  );
};

export default MasterContainer;
// Custom hook for accessing screen width
export const useScreenWidth = () => useContext(ScreenWidthContext);
export const usePlatform = () => useContext(PlatformContext);
export const useEnvironment = () => useContext(EnvironmentContext);

export const useGlobalLocation = () => {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error('useGlobalLocation is null');
  }
  return context;
};
